const decision_drawer_profiles = {
    'RES-210': {
      connected_records: [
        { label: 'Committee - terms of reference', value: 'Audit committee', icon: 'bi-clipboard-check' },
        { label: 'Delegation of authority', value: 'Audit committee mandate', icon: 'bi-diagram-3' },
        { label: 'Accountable owner', value: 'CFO - M. Khan', icon: 'bi-person-badge' },
        { label: 'Linked risk', value: 'R-05 - Supplier concentration', icon: 'bi-exclamation-triangle' },
        { label: 'Linked policy', value: 'Supplier risk-rating policy v2', icon: 'bi-folder2' },
        { label: 'Linked evidence', value: 'Quarterly review evidence folder', icon: 'bi-archive' },
        { label: 'Authorises', value: 'High-risk supplier segment', icon: 'bi-link-45deg' }
      ],
      enforcement_chain: [
        { title: 'Policy updated - Supplier risk-rating policy v2', subtitle: 'The quarterly review rule is now part of the active supplier policy.' },
        { title: 'Control created - Quarterly high-risk supplier review', subtitle: 'Controls library now tests the review cycle every quarter.' },
        { title: 'Review dates created - Mar / Jun / Sep / Dec', subtitle: 'The regulatory calendar marks the recurring review points.' },
        { title: '12 high-risk suppliers flagged', subtitle: 'Supplier module marks the current cohort for review.' },
        { title: 'Quarterly reviews assigned to Procurement', subtitle: 'My Tasks creates the recurring review task.' },
        { title: 'Evidence folder created', subtitle: 'Evidence vault stores each review pack and sign-off.' },
        { title: 'Implementation report routed to Audit Committee', subtitle: 'Progress reports show the resolution is in force.' }
      ]
    },
    'RES-204': {
      connected_records: [
        { label: 'Committee - terms of reference', value: 'Board', icon: 'bi-building' },
        { label: 'Delegation of authority', value: 'DoA-014 - above R 500k', icon: 'bi-diagram-3' },
        { label: 'Accountable owner', value: 'CEO - P. Naidoo', icon: 'bi-person-badge' },
        { label: 'Linked risk', value: 'R-04 - Unauthorised commitments above DoA', icon: 'bi-exclamation-triangle' },
        { label: 'Linked policy', value: 'Delegation of authority framework', icon: 'bi-folder2' },
        { label: 'Linked evidence', value: 'Signed reseller agreement', icon: 'bi-archive' },
        { label: 'Authorises', value: 'Platform support agreement', icon: 'bi-link-45deg' }
      ],
      enforcement_chain: [
        { title: 'No enforcement yet', subtitle: 'The decision is recorded but not yet turned into a control, calendar date or task.' },
        { title: 'Awaiting signature from Board', subtitle: 'The approval chain remains open until the final sign-off is captured.' },
        { title: 'DoA reminder queued', subtitle: 'A follow-up nudge is held against the board approval record.' }
      ]
    },
    'RES-198': {
      connected_records: [
        { label: 'Committee - terms of reference', value: 'Board', icon: 'bi-building' },
        { label: 'Delegation of authority', value: 'Board reserved matter', icon: 'bi-diagram-3' },
        { label: 'Accountable owner', value: 'CFO - M. Khan', icon: 'bi-person-badge' },
        { label: 'Linked risk', value: 'R-01 - Supplier fraud / payment fraud', icon: 'bi-exclamation-triangle' },
        { label: 'Linked policy', value: 'Procurement policy v3', icon: 'bi-folder2' },
        { label: 'Linked evidence', value: 'Board minutes - 12 Mar 2026', icon: 'bi-archive' },
        { label: 'Authorises', value: 'Procurement policy', icon: 'bi-link-45deg' }
      ],
      enforcement_chain: [
        { title: 'Policy published - Procurement policy v3', subtitle: 'The active version staff must follow is now live.' },
        { title: 'Controls re-mapped to v3', subtitle: '3 quote and threshold controls were updated.' },
        { title: 'Annual policy review date set', subtitle: 'Next review scheduled in the regulatory calendar.' },
        { title: 'Training brief issued', subtitle: 'Procurement staff are notified of the updated requirements.' }
      ]
    },
    'RES-191': {
      connected_records: [
        { label: 'Committee - terms of reference', value: 'EXCO', icon: 'bi-briefcase' },
        { label: 'Delegation of authority', value: 'Tender committee', icon: 'bi-diagram-3' },
        { label: 'Accountable owner', value: 'Procurement lead', icon: 'bi-person-badge' },
        { label: 'Linked risk', value: 'R-06 - Budget overrun - professional services', icon: 'bi-exclamation-triangle' },
        { label: 'Linked policy', value: 'Office procurement policy', icon: 'bi-folder2' },
        { label: 'Linked evidence', value: 'RFQ-211 evaluation pack', icon: 'bi-archive' },
        { label: 'Authorises', value: 'REQ-211 - Office renovation', icon: 'bi-link-45deg' }
      ],
      enforcement_chain: [
        { title: 'Costing still open', subtitle: 'The item is deferred until the budget and supplier options are tightened.' },
        { title: 'Budget hold remains in place', subtitle: 'Finance keeps the approval blocked until the next review.' },
        { title: 'RFQ pack expanded', subtitle: 'The evaluation pack is updated with extra supplier detail.' },
        { title: 'Re-evaluate supplier shortlist', subtitle: 'Procurement will bring the revised options back to EXCO.' }
      ]
    },
    'RES-187': {
      connected_records: [
        { label: 'Committee - terms of reference', value: 'Board', icon: 'bi-building' },
        { label: 'Delegation of authority', value: 'DoA-014 - above R 500k', icon: 'bi-diagram-3' },
        { label: 'Accountable owner', value: 'Company secretary', icon: 'bi-person-badge' },
        { label: 'Linked risk', value: 'Unlinked', icon: 'bi-exclamation-triangle' },
        { label: 'Linked policy', value: 'Contract management policy', icon: 'bi-folder2' },
        { label: 'Linked evidence', value: 'Signed MSA - GreenBuild', icon: 'bi-archive' },
        { label: 'Authorises', value: 'MSA - GreenBuild Projects', icon: 'bi-link-45deg' }
      ],
      enforcement_chain: [
        { title: 'MSA renewed', subtitle: 'The signed agreement is now the active contract record.' },
        { title: 'Contract register updated', subtitle: 'The supplier register points to the live MSA.' },
        { title: 'Renewal calendar set', subtitle: 'The next review date is scheduled automatically.' },
        { title: 'Supplier onboarding evidence filed', subtitle: 'The evidence vault now stores the signed pack.' }
      ]
    },
    'RES-180': {
      connected_records: [
        { label: 'Committee - terms of reference', value: 'Audit committee', icon: 'bi-clipboard-check' },
        { label: 'Delegation of authority', value: 'Companies Act s30', icon: 'bi-diagram-3' },
        { label: 'Accountable owner', value: 'CFO - M. Khan', icon: 'bi-person-badge' },
        { label: 'Linked risk', value: 'R-09 - Financial misstatement', icon: 'bi-exclamation-triangle' },
        { label: 'Linked policy', value: 'Financial reporting policy', icon: 'bi-folder2' },
        { label: 'Linked evidence', value: 'FY25 AFS pack', icon: 'bi-archive' },
        { label: 'Authorises', value: 'FY25 AFS', icon: 'bi-link-45deg' }
      ],
      enforcement_chain: [
        { title: 'Year-end close completed', subtitle: 'The annual reporting cycle is closed out and archived.' },
        { title: 'Audit sign-off attached', subtitle: 'Audit committee approval is linked to the final pack.' },
        { title: 'Board pack issued', subtitle: 'The signed statements are available to the board.' },
        { title: 'Filing confirmation recorded', subtitle: 'The disclosure trail now shows the filing outcome.' }
      ]
    }
};

function value_or_default(value, fallback_value) {
  const resolved_value = value || fallback_value;
  return resolved_value;
}

function build_base_drawer(row, approved_by, meeting_date, status_class) {
  const authority = value_or_default(row.under_authority, value_or_default(row.authorises, 'TBC'));
  const status = value_or_default(row.status, 'Passed');
  const subtitle = `Approved by ${approved_by}${meeting_date ? ` - ${meeting_date}` : ''}`;
  const base_drawer = {
    section: `RESOLUTION - ${value_or_default(row.ref, 'RES-000')} - ${approved_by}`.toUpperCase(),
    title: value_or_default(row.decision, 'Untitled decision'),
    subtitle,
    status,
    status_class,
    summary_cards: [
      { label: 'DECIDED IN', value: value_or_default(row.decided_in, approved_by) },
      { label: 'MEETING DATE', value: meeting_date },
      { label: 'AUTHORITY', value: authority },
      { label: 'STATUS', value: status, value_class: status_class }
    ]
  };
  return base_drawer;
}

function build_default_profile(row, approved_by) {
  const authority = value_or_default(row.under_authority, value_or_default(row.authorises, 'TBC'));
  const accountable_owner = value_or_default(row.accountable_owner, approved_by);
  const linked_records = {
    linked_risk: value_or_default(row.linked_risk, 'TBC'),
    linked_policy: value_or_default(row.linked_policy, 'TBC'),
    linked_evidence: value_or_default(row.linked_evidence, 'TBC'),
    authorises: value_or_default(row.authorises, 'TBC')
  };
  const default_profile = {
    connected_records: [
      { label: 'Committee - terms of reference', value: approved_by, icon: 'bi-building' },
      { label: 'Delegation of authority', value: authority, icon: 'bi-diagram-3' },
      { label: 'Accountable owner', value: accountable_owner, icon: 'bi-person-badge' },
      { label: 'Linked risk', value: linked_records.linked_risk, icon: 'bi-exclamation-triangle' },
      { label: 'Linked policy', value: linked_records.linked_policy, icon: 'bi-folder2' },
      { label: 'Linked evidence', value: linked_records.linked_evidence, icon: 'bi-archive' },
      { label: 'Authorises', value: linked_records.authorises, icon: 'bi-link-45deg' }
    ],
    enforcement_chain: [
      { title: 'Decision captured', subtitle: 'The resolution is ready to be linked to follow-up work.' },
      { title: 'Tracking records updated', subtitle: 'Calendar, controls and evidence can be connected from here.' }
    ]
  };
  return default_profile;
}

function profile_record_value(record, row) {
  const record_field_map = {
    'Linked risk': row.linked_risk,
    'Linked policy': row.linked_policy,
    'Linked evidence': row.linked_evidence,
    Authorises: row.authorises
  };
  const record_value = Reflect.get(record_field_map, record.label);
  return record_value;
}

function resolve_connected_record(record, row) {
  const next_value = profile_record_value(record, row);
  if (!next_value) return record;
  const connected_record = { ...record, value: next_value };
  return connected_record;
}

function resolve_profile(row, approved_by) {
  const base_profile = Reflect.get(decision_drawer_profiles, row.ref) || build_default_profile(row, approved_by);
  const connected_records = (base_profile.connected_records || []).map((record) => resolve_connected_record(record, row));
  const resolved_profile = {
    ...base_profile,
    connected_records
  };
  return resolved_profile;
}

export function build_decision_drawer(row) {
  if (!row) return null;
  const approved_by = value_or_default(row.approved_by, 'Board');
  const meeting_date = value_or_default(row.meeting_date, 'Pending');
  const status_class = value_or_default(row.status_class, 'bg-success-subtle text-success-emphasis');
  const base_drawer = build_base_drawer(row, approved_by, meeting_date, status_class);
  const drawer_profile = resolve_profile(row, approved_by);
  const drawer_model = {
    ...base_drawer,
    ...drawer_profile
  };

  return drawer_model;
}
